import styled from 'styled-components';

/** Header row: the "Additional Information" heading + the Show/Hide Data toggle button. */
export const SpdHeaderWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

/** Centres the spinner shown while the SPD values are being fetched (Show Data). */
export const LoadingIndicatorWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1.5rem 0;
`;
